import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export const CareMark = ({ className }) => (_jsxs("svg", { className: className, width: "36", height: "36", viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", children: [_jsx("path", { d: "M27 8H15a9 9 0 0 0-9 9v5a8 8 0 0 0 8 8h7", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round" }), _jsx("path", { d: "M30 15v6a5 5 0 0 1-5 5H15", stroke: "#5FB0C9", strokeWidth: "3", strokeLinecap: "round" }), _jsx("path", { d: "m14 17 4 4 9-10", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
export const Brand = () => (_jsxs(BrandName, { children: [_jsx(CareMark, {}), _jsxs("span", { children: ["AITech", _jsx("span", { children: "Care" })] })] }));
const BrandName = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  color: ${({ theme }) => theme.colors.navy900};
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.055em;
  white-space: nowrap;
  > span > span {
    font-weight: 400;
  }
  svg {
    flex: 0 0 auto;
  }
`;
